<template>
  <div id="operationLogs">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" type="text" v-model="searchData.createName" placeholder="操作人">
          </p>
          <p>
            <input class="allInput" type="text" v-model="searchData.docName" placeholder="医生姓名">
          </p>
          <p>
            <cander v-model="searchData.startTime" :className="'allInput'" placeholderName="开始时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <cander v-model="searchData.endTime" :minDate="searchData.startTime" :className="'allInput'" placeholderName="结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <button @click="getLogList(1)" class="redButtonTwo">搜索</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div style="width: 100%;overflow: auto">
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th class="t_c">操作类型</th>
            <th class="t_c">操作人</th>
            <th class="t_c">操作时间</th>
            <th class="t_c">医生姓名</th>
            <th class="t_c">省份</th>
            <th class="t_c">城市</th>
            <th class="t_c">医院</th>
            <th class="t_c">科室</th>
            <th class="t_c">DocCode</th>
          </tr>
          </thead>
          <tbody>
            <template v-if="logList.length > 0">
              <tr :key="index" v-for="(item, index) in logList">
                <td width="10%" class="t_c NoWrap">{{item.channel === 'P' ? '管理员解绑' : '用户注销'}}</td>
                <td width="10%" class="t_c NoWrap">{{item.createName}}</td>
                <td width="15%" class="t_c NoWrap">{{item.createTime}}</td>
                <td width="15%" class="t_c NoWrap">{{item.docName}}</td>
                <td width="10%" class="t_c NoWrap">{{item.province}}</td>
                <td width="10%" class="t_c NoWrap">{{item.city}}</td>
                <td width="10%" class="t_c NoWrap">{{item.instName}}</td>
                <td width="10%" class="t_c NoWrap">{{item.department}}</td>
                <td width="10%" class="t_c NoWrap">{{item.docCode}}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="9">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getLogList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
  </div>
</template>
<script>
export default {
  name: 'operationLogs',
  data () {
    return {
      searchData: {
        createName: '',
        docName: '',
        startTime: '',
        endTime: ''
      },
      logList: [],
      totalPage: 0,
      totalCount: 0,
      page: 1,
      pageSize: 10
    }
  },
  created () {
    // 获取日志
    this.getLogList(1)
  },
  mounted () {

  },
  methods: {
    // 获取日志
    getLogList (page) {
      this.page = page
      let startTime = this.searchData.startTime ? encodeURIComponent(this.searchData.startTime + ' 00:00:00') : ''
      let endTime = this.searchData.endTime ? encodeURIComponent(this.searchData.endTime + ' 23:59:59') : ''
      this.$axiox.get(`/api/Logs/UnbindHCPQueryList?createName=${this.searchData.createName}&startTime=${startTime}&endTime=${endTime}&docName=${this.searchData.docName}&PageIndex=${page}&PageSize=${this.pageSize}`).then(res => {
        console.log(res, 'getLogList')
        if (res.data && res.data.length > 0) {
          this.logList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.logList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/userManager/operationLogs.vue